import {
    Box,
    Icon,
    IconButton,
    MobileStepper,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { AdProjectPhotoDto } from "../../../api/psc";
import { toJalaliDate } from "../../../utils/date";

export default function AdProjectDetailPhotos(props: {
    item: AdProjectPhotoDto;
}) {
    const [selectedIndex, setSelectedIndex] = useState(0);

    const hasMultipleImages = props.item.imageIds.length > 1;

    const handleNext = () => {
        setSelectedIndex((step) => step + 1);
    };

    const handleBack = () => {
        setSelectedIndex((step) => step - 1);
    };

    return (
        <Box>
            <Box sx={{ position: "relative", float: "left" }}>
                <img
                    src={props.item.imageIds[selectedIndex]}
                    style={{ float: "left", width: "100%", height: "100%" }}
                />

                <Typography
                    color="primary"
                    sx={{
                        position: "absolute",
                        right: 16,
                        bottom: 16,
                        px: 2,
                        py: 1,
                        borderRadius: 20,
                        bgcolor: "background.default",
                    }}
                >
                    {toJalaliDate(props.item.createDate)}
                </Typography>

                {hasMultipleImages && (
                    <>
                        <IconButton
                            disabled={
                                selectedIndex === props.item.imageIds.length - 1
                            }
                            onClick={handleNext}
                            sx={{
                                position: "absolute",
                                right: 16,
                                top: "40%",
                                background: "rgba(0,0,0,0.1)",
                                backdropFilter: "blur(20px)",
                            }}
                        >
                            <Icon sx={{ fontSize: "30px", color: "white" }}>
                                chevron_left
                            </Icon>
                        </IconButton>

                        <IconButton
                            disabled={selectedIndex === 0}
                            onClick={handleBack}
                            sx={{
                                position: "absolute",
                                left: 16,
                                top: "40%",
                                background: "rgba(0,0,0,0.1)",
                                backdropFilter: "blur(20px)",
                            }}
                        >
                            <Icon sx={{ fontSize: "30px", color: "white" }}>
                                chevron_right
                            </Icon>
                        </IconButton>

                        <MobileStepper
                            sx={{
                                position: "absolute",
                                bottom: 0,
                                height: "35px",
                                width: "100%",
                                justifyContent: "center",
                            }}
                            steps={props.item.imageIds.length}
                            position="static"
                            activeStep={selectedIndex}
                            nextButton={<></>}
                            backButton={<></>}
                        />
                    </>
                )}
            </Box>
        </Box>
    );
}
